<template>
  <div class="page">
    <div class="name">支付聚合平台</div>
    <div class="content">
      <!-- 左侧图案 -->
      <leftImg></leftImg>
      <!-- 注册 -->
      <div class="right">
        <p class="name">重置密码</p>
        <div class="info">请输入您的邮箱地址或手机号</div>
        <div class="form">
          <el-input
            class="mailbox"
            v-model="userName"
            @input="changeStatus"
            placeholder="请输入您的邮箱地址或手机号"
            maxlength="64"
          ></el-input>
          <div class="error">{{ errorMsg }}</div>
          <el-button :class="[!btnStatus ? 'btn-status' : '', 'btn']" type="primary" @click="btnStatus ? goNext() : ''"
            >下一步</el-button
          >
          <div class="back">
            <span @click="backLogin('login')">返回登录</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftImg from '@login/components/leftImg';
import checkString from '@/util/CheckString';
import { mapActions } from 'vuex';
export default {
  components: {
    leftImg,
  },
  data() {
    return {
      userName: '', // 登录账号
      btnStatus: false, //按钮可点击状态
      errorMsg: '', // 表单错误提示语
    };
  },
  methods: {
    ...mapActions('login', ['checkAccountRegistered', 'getEmailVerifyCode', 'getPhoneVerifyCode']),
    // 发送验证码
    async goNext() {
      this.btnStatus = false;
      // 判断账号格式类型
      const checkTypeRes = this.handleCheckType();
      // 判断当前账号是否注册过 没注册提示更换账号
      if (checkTypeRes !== 'TYPE_ERROR') {
        const checkRegisteredRes = await this.handleCheckRegistered(checkTypeRes);
        if (checkRegisteredRes === true) {
          // 是已注册的账号 => 根据类型发送不同的请求（手机验证或邮箱验证）
          this.handleSubmitVerify(checkTypeRes);
        }
      }
    },

    // 判断账号格式类型
    handleCheckType() {
      console.log('userName: ', this.userName);
      // 校验是否为邮箱格式
      const checkEmailRes = checkString(this.userName, 'email');
      if (!checkEmailRes) {
        // 不是邮箱 => 验证是否为手机号格式
        const checkPhoneRes = checkString(this.userName, 'phone');
        if (!checkPhoneRes) {
          // 不是手机 => 提示账号格式错误
          this.errorMsg = '邮箱地址或手机号格式错误';
          return 'TYPE_ERROR';
        }
        // 是手机 => 返回手机类型
        this.errorMsg = '';
        return 'TYPE_PHONE';
      }
      // 是邮箱 => 返回邮箱类型
      this.errorMsg = '';
      return 'TYPE_EMAIL';
    },

    // 判断账号是否注册过
    async handleCheckRegistered(checkTypeRes) {
      // 前端格式校验通过 => 发请求
      const { userName } = this;
      const checkRes = await this.checkAccountRegistered({ userName });
      if (checkRes !== 'success') {
        // 账号未注册 => 判断账号类型 => 展示对应的错误提示语
        switch (checkTypeRes) {
          case 'TYPE_PHONE':
            this.errorMsg = '手机号错误，请用邮箱验证';
            break;
          case 'TYPE_EMAIL':
            this.errorMsg = '邮箱地址错误，请用手机号验证';
            break;
        }
        return false;
      } else {
        return true;
      }
    },

    // 发送验证码请求
    async handleSubmitVerify(checkTypeRes) {
      if (checkTypeRes === 'TYPE_PHONE') {
        // 发送手机验证码请求
        const authKey = await this.getPhoneVerifyCode({ account: this.userName });
        if (authKey) {
          this.$router.push({
            path: '/forget/stepTwo',
            query: { phoneAccount: this.userName },
          });
          return;
        }
        // 手机验证码返回值异常
        this.btnStatus = true;
        this.$message.error('手机验证码发送失败，请重试');
      } else if (checkTypeRes === 'TYPE_EMAIL') {
        // 发送邮箱验证码请求
        const authKey = await this.getEmailVerifyCode({ account: this.userName });
        if (authKey) {
          this.$router.push({
            path: '/forget/stepTwo',
            query: { emailAccount: this.userName },
          });
          return;
        }
        // 验证邮件返回值异常
        this.btnStatus = true;
        this.$message.error('验证邮件发送失败，请重试');
      }
    },

    // 修改邮箱/协议选中状态
    changeStatus() {
      if (this.userName != '') {
        this.btnStatus = true;
      } else {
        this.btnStatus = false;
      }
    },
    // 返回登录
    backLogin() {
      this.$router.replace({ path: '/login' });
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 90vh;
  display: flex;
  flex-direction: column;
  padding: 5vh;
}
.name {
  font-size: 22px;
  color: #333;
  font-family: Noto Sans S Chinese;
  font-weight: 400;
}
.content {
  display: flex;
  width: 800px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(67, 89, 183, 0.2);
  border-radius: 8px;
  margin: auto;
}
.right {
  width: 50%;
  height: 400px;
  .name {
    font-size: 22px;
    color: #333;
    padding: 18px 0;
    text-align: center;
  }
  .info {
    font-size: 14px;
    padding: 0 0 5px 65px;
    line-height: 25px;
  }
  .form {
    text-align: center;
    .error {
      color: #ff5f5f;
      font-size: 14px;
      padding: 10px 60px;
      text-align: left;
    }
  }
  .mailbox {
    width: 300px;
  }
  .btn {
    width: 300px;
    font-size: 14px;
    font-family: Helvetica Neue;
    font-weight: 400;
    margin-bottom: 30px;
  }
  .btn-status {
    opacity: 0.4;
  }
  .back {
    font-size: 14px;
    color: #4359b7;
    cursor: pointer;
  }
}
</style>
